import {useMemo} from 'react';

import type {RunHistoryKeyType} from '../../../../types/run';
import {useExistingPanelsByKey} from './useExistingPanelsByKey';
import {useNextGenSearchedKeys, useSearchedKeys} from './useSearchedKeys';

export const useQuickAddKeys = (
  searchStr = '',
  keyType?: RunHistoryKeyType,
  enabled = true
) => {
  const searchedKeys = useSearchedKeys(searchStr, keyType, enabled);
  const existingPanels = useExistingPanelsByKey(enabled);
  const keysWithNoPanels = useMemo(
    () =>
      searchedKeys.filter(([key]) => !existingPanels.global.get(key)?.length),
    [searchedKeys, existingPanels]
  );
  return {
    searchedKeys,
    existingPanels,
    keysWithNoPanels,
  };
};

export const useNextGenQuickAddKeys = (searchStr: string, pageSize: number) => {
  const existingPanels = useExistingPanelsByKey();
  const {
    keys,
    hasNextPage,
    fetchNextPage,
    retryInitialFetch,
    isInitialLoading,
    isLoadingMore,
    initialError,
    searchErrorMessage,
    loadMoreError,
  } = useNextGenSearchedKeys(searchStr, pageSize);

  const keysWithNoPanels = useMemo(() => {
    return keys.filter(([key]) => !existingPanels.global.get(key)?.length);
  }, [keys, existingPanels]);

  return {
    searchedKeys: keys,
    hasNextPage,
    fetchNextPage,
    retryInitialFetch,
    isInitialLoading,
    isLoadingMore,
    initialError,
    searchErrorMessage,
    loadMoreError,

    existingPanels,
    keysWithNoPanels,
  };
};
